export const GOLONGAN_STYLE = {
  Siaga: "bg-emerald-50 text-emerald-800 border-emerald-200",
  Penggalang: "bg-red-50 text-red-800 border-red-200",
  Penegak: "bg-amber-50 text-amber-800 border-amber-200",
  Pandega: "bg-stone-100 text-stone-800 border-stone-300",
};

export const STATUS_STYLE = {
  Pending: "bg-amber-100 text-amber-900 border-amber-300",
  Validated: "bg-sky-100 text-sky-900 border-sky-300",
  Approved: "bg-emerald-100 text-emerald-900 border-emerald-300",
  Rejected: "bg-rose-100 text-rose-900 border-rose-300",
};

export function GolonganBadge({ value }) {
  if (!value) return <span className="text-xs text-muted-foreground">—</span>;
  return (
    <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${GOLONGAN_STYLE[value] || "bg-stone-100 text-stone-700 border-stone-200"}`}>
      {value}
    </span>
  );
}

export function StatusBadge({ value }) {
  return (
    <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${STATUS_STYLE[value] || ""}`}>
      {value === "Pending" ? "Menunggu Pembina" : value === "Validated" ? "Menunggu Kwarcab" : value === "Approved" ? "Terverifikasi" : value === "Rejected" ? "Ditolak" : value}
    </span>
  );
}
